import React from "react";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/lib/api";

export default function WhatsAppButton() {
  const href = `https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(
    "Hi KSPB, I'm interested in your GPS tracking solutions."
  )}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-button"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <div className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
      <div className="relative flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[#25D366] text-white shadow-2xl shadow-emerald-500/30 hover:scale-105 active:scale-95 transition-transform">
        <MessageCircle className="w-5 h-5" />
        <span className="text-sm font-semibold hidden sm:inline">Chat with us</span>
      </div>
    </a>
  );
}
